// テキストを変更する関数
function changeNewAddText(element) {
  if (element.textContent.trim() === 'BOXの商品を変更する') {
    element.textContent = 'メニューを変更する';
    console.log('Text successfully changed to: メニューを変更する', element);
  } else {
    console.log('Text not changed. Current text:', element.textContent);
  }
}

// 要素を検索し、テキストを変更する関数
function findAndChangeText() {
  const elements = document.querySelectorAll('.huckleberry-subscription-detail-btn.new-add, .new-add');
  elements.forEach((element, index) => {
    changeNewAddText(element);
  });
}

// カスタムセレクトを適用する関数（更新）
function applyCustomSelects() {
  // Polaris-FormLayout__Item select に対する処理
  document.querySelectorAll('.Polaris-FormLayout__Item select:not(.custom-select-processed)').forEach(select => {
    if (!select.nextElementSibling || !select.nextElementSibling.classList.contains('custom-options-container')) {
      createCustomSelect(select);
      select.classList.add('custom-select-processed');
    }
  });

  // formLayout 内の最初の section 内の select に対する処理
  const formLayout = document.querySelector('.formLayout');
  if (formLayout) {
    const firstSectionSelect = formLayout.querySelector('section:first-child select:not(.custom-select-processed)');
    if (firstSectionSelect) {
      createCustomSelect(firstSectionSelect);
      firstSectionSelect.classList.add('custom-select-processed');
    }
  }
}

// カスタムセレクト関連の関数（更新）
function createCustomSelect(select) {
  if (!select || select.classList.contains('custom-select-processed')) return;
  
  // 既存のカスタムオプションコンテナがある場合は削除
  const existingContainer = select.nextElementSibling;
  if (existingContainer && existingContainer.classList.contains('custom-options-container')) {
    existingContainer.remove();
  }

  const container = document.createElement('div');
  container.className = 'custom-options-container';
  
  const options = Array.from(select.options).slice(1); // 最初の "選択してください" を除外
  
  // ===== URLパラメータから初期選択を決定 =====
  // 例: ?plan=8 → option テキストに "8個" を含むものを選択
  const urlParams = new URLSearchParams(window.location.search);
  const planParam = urlParams.get('plan');
  
  let initialIndex = 0; // デフォルト：最初のオプション
  if (planParam) {
    const foundIndex = options.findIndex(opt =>
      opt.textContent.includes(planParam + '個')
    );
    if (foundIndex !== -1) {
      initialIndex = foundIndex;
    }
  }
  // =========================================
  
  options.forEach((option, index) => {
    const button = document.createElement('button');
    const optionText = option.textContent.split(' - ');
    button.textContent = optionText.length > 1 ? `${optionText[0]}-${optionText[1]}` : optionText[0];
    button.className = 'custom-option';
    button.dataset.value = option.value;
    
    if (index === initialIndex) {
      button.classList.add('selected');
      select.value = option.value;
      // アプリ側のロジック（プラン連動の表示など）に初期値を反映させる
      setTimeout(() => {
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }, 0);
    }
    
    button.addEventListener('click', function() {
      select.value = this.dataset.value;
      container.querySelectorAll('.custom-option').forEach(btn => btn.classList.remove('selected'));
      this.classList.add('selected');
      
      const event = new Event('change', { bubbles: true });
      select.dispatchEvent(event);
    });
    
    container.appendChild(button);
  });
  
  select.style.display = 'none';
  select.parentNode.insertBefore(container, select.nextSibling);
  select.classList.add('custom-select-processed');
}

// 共通のMutationObserver設定
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          checkAndSetupGridProduct(node);
          applyCustomSelects(); // 新しく追加された要素に対してカスタムセレクトを適用
          checkAndHideCustomOptionsContainer(node);
          modifyLayout();
          setupNextButton();
          setupBackButton();
          
          if (node.classList && (node.classList.contains('new-add') || node.classList.contains('huckleberry-subscription-detail-btn'))) {
            changeNewAddText(node);
          }
          const newAddElements = node.querySelectorAll('.huckleberry-subscription-detail-btn.new-add, .new-add');
          newAddElements.forEach(changeNewAddText);
        }
      });
    }
  });
});

// 監視の開始
observer.observe(document.body, { childList: true, subtree: true });

// grid-product関連の関数
function checkAndSetupGridProduct(element) {
  if (element.classList.contains('grid-product')) {
    setupGridProduct(element);
  } else {
    element.querySelectorAll('.grid-product').forEach(setupGridProduct);
  }
}

function setupGridProduct(product) {
  const input = product.querySelector('input[type="number"]');
  if (input) {
    checkInputAndSetBorder(input, product);
    const minusButton = product.querySelector('button:first-of-type');
    const plusButton = product.querySelector('button:last-of-type');
    if (minusButton) {
      minusButton.addEventListener('click', () => {
        setTimeout(() => checkInputAndSetBorder(input, product), 0);
      });
    }
    if (plusButton) {
      plusButton.addEventListener('click', () => {
        setTimeout(() => checkInputAndSetBorder(input, product), 0);
      });
    }
  }
}

function checkInputAndSetBorder(input, product) {
  if (input.value.trim() !== '' && !isNaN(input.value) && parseInt(input.value) > 0) {
    product.style.border = '1px solid #000';
  } else {
    product.style.border = 'none';
  }
}

// .Polaris-ResourceList__ResourceListWrapperが存在する場合に.custom-options-containerを非表示にする
function checkAndHideCustomOptionsContainer(element) {
  const formLayoutItem = element.closest('.Polaris-FormLayout__Item');
  if (formLayoutItem) {
    if (formLayoutItem.querySelector('.Polaris-ResourceList__ResourceListWrapper')) {
      const customOptionsContainer = formLayoutItem.querySelector('.custom-options-container');
      if (customOptionsContainer) {
        customOptionsContainer.style.display = 'none';
      }
    }
  }
}

// .Polaris-ResourceList__ResourceListWrapperが存在する場合にレイアウトを修正する
function modifyLayout() {
  const resourceListWrapper = document.querySelector('.Polaris-ResourceList__ResourceListWrapper');
  if (resourceListWrapper) {
    const formLayout = document.querySelector('.Polaris-FormLayout');
    if (formLayout) {
      const thirdItem = formLayout.querySelector('.Polaris-FormLayout__Item:nth-child(3)');
      const fourthItem = formLayout.querySelector('.Polaris-FormLayout__Item:nth-child(4)');
      
      if (thirdItem && fourthItem) {
        // 既存のラッパーがあれば削除
        const existingWrapper = thirdItem.parentElement;
        if (existingWrapper.classList.contains('custom-wrapper')) {
          existingWrapper.parentNode.insertBefore(thirdItem, existingWrapper);
          existingWrapper.parentNode.insertBefore(fourthItem, existingWrapper);
          existingWrapper.parentNode.removeChild(existingWrapper);
        }
        
        // 新しいラッパーを作成
        const wrapper = document.createElement('div');
        wrapper.className = 'custom-wrapper';
        
        // 要素をラッパーで囲む
        thirdItem.parentNode.insertBefore(wrapper, thirdItem);
        wrapper.appendChild(thirdItem);
        wrapper.appendChild(fourthItem);
      }
    }
  }
}

// custom-wrapperを追加する関数
function addCustomWrapper() {
  const formLayout = document.querySelector('.Polaris-FormLayout');
  if (formLayout) {
    const thirdItem = formLayout.querySelector('.Polaris-FormLayout__Item:nth-child(3)');
    const fourthItem = formLayout.querySelector('.Polaris-FormLayout__Item:nth-child(4)');
    
    if (thirdItem && fourthItem && !thirdItem.parentElement.classList.contains('custom-wrapper')) {
      const wrapper = document.createElement('div');
      wrapper.className = 'custom-wrapper';
      
      thirdItem.parentNode.insertBefore(wrapper, thirdItem);
      wrapper.appendChild(thirdItem);
      wrapper.appendChild(fourthItem);
      
      console.log('custom-wrapper has been added');
    }
  }
}

// custom-wrapperを解除し、ページをリロードする関数
function unwrapCustomWrapperAndReload(event) {
  event.preventDefault();  // デフォルトの動作を防ぐ（ページ遷移を止める）
  const wrapper = document.querySelector('.custom-wrapper');
  if (wrapper) {
    const parent = wrapper.parentNode;
    while (wrapper.firstChild) {
      parent.insertBefore(wrapper.firstChild, wrapper);
    }
    parent.removeChild(wrapper);
    console.log('custom-wrapper has been removed');
  } else {
    console.log('No custom-wrapper found');
  }
  // mainタグに擬似要素を追加するクラスを付与
  const main = document.querySelector('main');
  if (main) {
    main.classList.add('main-overlay');
    console.log('Overlay added to main');
  } else {
    console.log('main tag not found');
  }
  
  // ページをリロード
  console.log('Reloading page...');
  window.location.reload();
}


// 次へボタンにイベントリスナーを追加する関数
function setupNextButton() {
  const nextButton = document.querySelector('.product-form__cart-submit');
  if (nextButton) {
    nextButton.removeEventListener('click', addCustomWrapper);
    nextButton.addEventListener('click', addCustomWrapper);
    console.log('Event listener added to next button');
  }
}

// 戻るボタンにイベントリスナーを追加する関数を更新
function setupBackButton() {
  const backButtons = document.querySelectorAll('.Polaris-Button--fullWidth');
  backButtons.forEach(button => {
    const buttonText = button.querySelector('.Polaris-Button__Text');
    if (buttonText && buttonText.textContent.trim() === '戻る') {
      button.removeEventListener('click', unwrapCustomWrapperAndReload);
      button.addEventListener('click', unwrapCustomWrapperAndReload);
      console.log('Event listener added to back button:', button);
    }
  });
}

// 初期化処理
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.grid-product').forEach(setupGridProduct);
  applyCustomSelects();
  document.querySelectorAll('.Polaris-FormLayout__Item').forEach(checkAndHideCustomOptionsContainer);
  
  modifyLayout();
  setupNextButton();
  setupBackButton();
  findAndChangeText();

  // 定期的に実行する処理
  setInterval(() => {
    findAndChangeText();
    applyCustomSelects();
  }, 2000);
  
  const targetElement = document.querySelector("#boxContent > div > div.Polaris-Page > div > div > div > div.Polaris-FormLayout > div:nth-child(3) > div");
  if (targetElement) {
    targetElement.style.textAlign = "center";
  }
  
  // デバッグ用：ボタンクリックイベントの監視
  document.addEventListener('click', function(event) {
    if (event.target.closest('button')) {
      console.log('Button clicked:', event.target.closest('button'));
    }
  }, true);
});

document.querySelector("#root > div.wrap > div.content.content-left > section:nth-child(1) > article:nth-child(4) > div:nth-child(4) > a > span").textContent = document.querySelector("#root > div.wrap > div.content.content-left > section:nth-child(1) > article:nth-child(4) > div:nth-child(4) > a > span").textContent.replace('BOXの商品を変更する', 'メニューを変更する');